<template>
	<div class="order_list">
		<van-list v-if="total" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
			<!--检测中心-->
			<base-card
				class="mt-28"
				v-for="item in list"
				:key="item.id"
				:title="item.organName"
				title-icon="institution.png"
				title-icon-width="23"
			>
				<infor-card :patientName="item.patientName" :list="item._list" />
				<van-button
					type="primary"
					block
					class="mt-28"
					@click="$router.push(`/report/view-report/${ item.id }`)"
				>查看报告 <van-icon name="arrow" /> </van-button>
			</base-card>
		</van-list>
		<base-empty v-else desc="暂无订单" :icon="0"></base-empty>
	</div>
</template>

<script>
export default {
	name: 'orderList',
	data: () => ({
		loading: false,
		list: [],
		total: 0,
		page: 1,
		limit: 10
	}),
	computed: {
		finished () {
			return this.total <= this.list.length
		}
	},
	created (){
		this.getList()
	},
	methods: {
		async getList () {
			this.loading = true
			const res = await this.$api.order.page({
				limit: this.limit,
				page: this.page,
				orderBy: "complete_time",
        		desc: 1,
				detectStatus: 3
			})
			this.loading = false
			if (!res.code) {
				res.data.list.forEach(item => {
					item._list = this.listDataFormat(item) || []
					item._listNum = `共${ (item.productList || []).length}件`
					item._listTotalPrice = (item.productList || []).reduce((v, d) => (v + d.totalPrice), 0)
					item._sampleType = (item.detectType || '').split('&').map(val => ({ 1: '血液', 2: '脑脊液' }[val])).join('+')
				})
				this.list = [...this.list, ...res.data.list]
				this.total = res.data.total
				this.page ++
			}
		},
		// list 数据转化
		listDataFormat (data) {
			return (data.productList || []).map(item => ({
				...item,
				title: item.productName,
				content: (item.itemList || []).map(val => val.itemName).join('、'),
				desc: [{ label: `￥${ item.totalPrice }`, value: `x${ item.quantity }` }]
			}))
		},
	}
};
</script>

<style scoped lang="less">
.order_list {
	padding: 18px 32px;
}
</style>

<style lang="less">
.order_list {
	.van-tabs {
		.van-tabs__line{ height: 4px; }
		.van-tab {
			.van-tab__text {
				font-family: PingFangSC-Regular;
				font-size: 32px;
				font-weight: normal;
				text-align: center;
				color: #BBBFC4;
			}
			&.van-tab--active {
				.van-tab__text {
					color: #000;
				}
			}
		}
	}
}
</style>
